<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h5 class="float-left"><i class='fa fa-search'></i> Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form>
              <b-row>
                <b-col sm="3">
                  <p-input v-model.trim="form.orderNumber" label="Order Number" name="orderNumber" :handler="$v" :formData="form"/>
                </b-col>
                <b-col sm="3">
                  <p-input v-model.trim="form.username" label="Username" name="username" :handler="$v" :formData="form"/>
                </b-col>
                <b-col sm="3">
                  <p-input v-model.trim="form.month" label="Report Month" name="month" :handler="$v" :formData="form" type="month"/>
                </b-col>
                <b-col sm="3">
                  <p-dropdown v-model.trim="form.status" class="dropdown-select" label="Status" name="status" :handler="$v" :formData="form" :options="statusOption" textKey="id" textValue="label"/>
                </b-col>
                <b-col sm="12">
                  <b-btn variant="primary" @click="search()">Search</b-btn>
                </b-col>
              </b-row>
            </b-form>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card no-body>
          <b-card-header>
            <h3 class="float-left"><i class='fa fa-tag'></i> Monthly Tier Bonus</h3>
          </b-card-header>
          <b-card-body>
            <div class="overflow-auto">
              <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields">
                <template v-slot:cell(Status)="data">
                  <b-badge v-if="data.item.Status === 0" variant="warning">Created</b-badge>
                  <b-badge v-else-if="data.item.Status === 1" variant="info">Processing</b-badge>
                  <b-badge v-else-if="data.item.Status === 2" variant="success">Success</b-badge>
                  <b-badge v-else-if="data.item.Status === 3" variant="danger">Failed</b-badge>
                  <b-badge v-else-if="data.item.Status === 4" variant="success">Manual Handle</b-badge>
                </template>
                <template v-slot:cell(TotalPoints)="data">
                  {{ format(data.item.TotalPoints, '0,0')}}
                </template>
                <template v-slot:cell(RequiredPoints)="data">
                  {{ format(data.item.RequiredPoints, '0,0')}}
                </template>
                <template v-slot:cell(BonusPoints)="data">
                  {{ format(data.item.BonusPoints, '0,0')}}
                </template>
                <template v-slot:cell(MarkOperator)="data">
                  <b-btn v-if="[0, 1, 3].includes(data.item.Status) && checkAccessPrivilege('JeetPrivilege.VipProgram.Mark')" variant="danger" class="btn-sm" @click="markTransaction(data.item)">Mark</b-btn>
                  <span v-else-if="data.item.Status === 4">{{ data.item.MarkOperator }}</span>
                </template>
              </b-table>
            </div>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import numeral from 'numeral'
import { PInput, PDropdown } from '../../../components'
const {required} = require('vuelidate/lib/validators')
const _ = require('underscore')
const moment = require('moment-timezone')

export default {
  name: 'month-tier-bonus-table',
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      items: [],
      fields: [],
      leftField: [
        {key: 'OrderNumber', label: 'Ticket Number'},
        {key: 'Username', label: 'Username'}
      ],
      rightField: [
        {key: 'TotalPoints', label: 'Total Points'},
        {key: 'RequiredPoints', label: 'RequiredPoints'},
        {key: 'BonusPoints', label: 'Bonus Points'},
        {key: 'Status', label: 'Status'},
        {key: 'AddTime', label: 'Added On'},
        {key: 'MarkOperator', label: 'Mark Operator'}
      ],
      perPage: 50,
      currentPage: 1,
      rowCount: 0,
      statusOption: [
        {id: '0', label: 'Created'},
        {id: '1', label: 'Processing'},
        {id: '2', label: 'Success'},
        {id: '3', label: 'Failed'},
        {id: '4', label: 'Manual Handle'}
      ],
      form: {
        orderNumber: '',
        username: '',
        month: moment().tz('Asia/Taipei').format('YYYY-MM'),
        status: null,
        errorMessages: {
          month: {
            required: 'Please select the month'
          }
        }
      }
    }
  },
  validations: {
    form: {
      orderNumber: {},
      username: {},
      month: {
        required
      },
      status: {}
    }
  },
  components: {
    PInput,
    PDropdown
  },
  watch: {
    currentPage: function (val) {
      this.search()
    }
  },
  methods: {
    getRowCount (items) {
      return items.length
    },
    format (num, fmt) {
      return numeral(num).format(fmt)
    },
    async search () {
      try {
        Events.$emit('loader')
        let queryStr = `orderNumber=${this.form.orderNumber}&username=${this.form.username}&status=${this.form.status || ''}&month=${this.form.month}`
        let { data } = await this.$http.get(this.API_ENDPOINT + '/jeetprivilege/vipProgram/getList?' + queryStr, { headers: { 'Content-Type': 'application/json' } })
        if (data.result.length > 0) {
          this.setFields(false, data.result)
        }
        const $this = this
        this.items = _.map(data.result, function (x) {
          let details = JSON.parse(x.Details)
          for (let i in details) {
            details[i] = $this.format(parseInt(details[i]), '0,0')
          }
          delete x.Details
          return { ...x, ...details }
        })
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    setFields (init = false, items) {
      if (init) {
        this.fields = [ ...this.leftField, ...this.rightField ]
      } else {
        let details = JSON.parse(items[0].Details)
        let detailFields = []
        for (let x in details) {
          let l = x.charAt(0).toUpperCase() + x.slice(1)
          let label = l.replace(/([A-Z])/g, ' $1').trim()
          detailFields.push({ key: x, label: label })
        }
        this.fields = [ ...this.leftField, ...detailFields, ...this.rightField ]
      }
    },
    async markTransaction (item) {
      try {
        Events.$emit('loader')
        await this.$http.post(this.API_ENDPOINT + '/jeetprivilege/vipProgram/mark', {
          orderNumber: item.OrderNumber
        })
        Events.$emit('alert', VueNotifications.types.success, 'Success', 'Ticket Marked Successfully')
        this.search()
      } catch (err) {
        console.log('this is an error ', err)
        Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      } finally {
        Events.$emit('loader')
      }
    },
    checkAccessPrivilege (module, title = false) {
      if (!module) return true
      if (title) return (JSON.stringify(this.PRIVILEGE).includes(module))
      return this.PRIVILEGE.includes(module)
    }
  },
  async created () {
    this.setFields(true)
    await this.search()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/jeetPrivilege/vipProgram/MonthlyTierBonusTable.vue